module.exports = __webpack_public_path__ + "static/media/fa-map-marker.f30da707.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fa-map-marker.svg
// module id = 163
// module chunks = 7